export function getMessageId(search: string) {
  const queryParams = new URLSearchParams(search);

  return queryParams.get('messageId');
}
